export class SearchOffersModel {
    searchTerm: string;
    categoryIds: number[];
    collectionIds: number[];
    tagIds: number[];
    priceRanges: number[];
    ratings: number[];
    locations: string[];
}
